/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_TitleInputs */

const et_audit_title = /** @type {(inputs: Audit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasuta veebilehe audit — ScalingWebs`)
};

const en_audit_title = /** @type {(inputs: Audit_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free Website Audit — ScalingWebs`)
};

/**
* | output |
* | --- |
* | "Free Website Audit — ScalingWebs" |
*
* @param {Audit_TitleInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_title = /** @type {((inputs?: Audit_TitleInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_TitleInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_audit_title(inputs)
	return en_audit_title(inputs)
});